<template>
  <cac-page class="cac-home">
    <welcome-banner :page-key="componentUniqueKey" />
    <!--
      Hidden until we finish implementation.
      See PDEV-12913
      <client-headline-section />
    -->

    <!-- This margin-top is only here while the client-headline-section is hidden -->
    <page-section
      id="cac-home__content-wrapper"
      class="d-md-block d-none"
      style="margin-top: 40px;"
    >
      <div class="row">
        <div
          :class="showFeaturedContent ? 'col-sm-11' : 'col-sm-18'"
          class="action-links__wrapper"
        >
          <action-links />
        </div>
        <div
          v-if="showFeaturedContent"
          class="col-sm-7 featured-content__wrapper"
        >
          <featured-content />
        </div>
      </div>
    </page-section>
  </cac-page>
</template>
<script>
import { mapGetters } from "vuex";

import CacPage from "CivicActionCenterComponents/layout/CACPage.vue";
import PageSection from "CivicActionCenterComponents/shared/PageSection.vue";

import ActionLinks from "CivicActionCenterComponents/sections/Home/ActionLinks.vue";
import FeaturedContent from "CivicActionCenterComponents/sections/Home/FeaturedContent.vue";
import WelcomeBanner from "CivicActionCenterComponents/sections/WelcomeBanner.vue";

import SharedMixin from "JS/mixins/campaign/civicactioncenter/shared";

import STATE from "Constants/campaign/civicactioncenter/state";

const hasAdvocateContext = `${STATE.SCOPE_CAC}/${STATE.HAS_ADVOCATE}`;
const selectedLanguageContext = `${STATE.SCOPE_CAC}/${STATE.SELECTED_LANGUAGE}`;

const hasFeaturedContentContext = `${STATE.SCOPE_CAMPAIGN}/${
  STATE.HAS_FEATURED_CONTENT
}`;

export default {
  name: "Home",
  components: {
    CacPage,
    PageSection,
    ActionLinks,
    FeaturedContent,
    WelcomeBanner
  },
  mixins: [SharedMixin],
  computed: {
    ...mapGetters({
      hasAdvocate: hasAdvocateContext,
      selectedLanguage: selectedLanguageContext,
      hasFeaturedContent: hasFeaturedContentContext
    }),
    isEnglishLanguage() {
      return this.selectedLanguage === "en";
    },
    showFeaturedContent() {
      return this.isEnglishLanguage && this.hasFeaturedContent;
    }
  }
};
</script>
